/**
 * Format currency values
 * @param {number} value - Value in USD
 * @returns {string} Formatted string (e.g., "$10.5M")
 */
export function formatCurrency(value) {
  if (value >= 1000000) {
    return `$${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `$${(value / 1000).toFixed(1)}K`;
  }
  return `$${value.toFixed(0)}`;
}

/**
 * Format percentage values
 * @param {number} value - Decimal value (e.g., 0.35)
 * @returns {string} Formatted string (e.g., "35%")
 */
export function formatPercentage(value) {
  return `${(value * 100).toFixed(1)}%`;
}

/**
 * Format large numbers with commas
 * @param {number} value - Number to format
 * @returns {string} Formatted string (e.g., "1,234")
 */
export function formatNumber(value) {
  return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
}
